/** Countries where FedEx/UPS expect a state or province code on the label. */
const STATE_REQUIRED_COUNTRY_CODES = new Set([
  'US',
  'CA',
  'AU',
  'MX',
  'IN',
  'BR',
  'IT',
  'ES',
  'JP',
]);

export function requiresStateOrProvince(countryCode: string): boolean {
  return STATE_REQUIRED_COUNTRY_CODES.has(countryCode.trim().toUpperCase());
}

export function normalizeCountryCode(raw: string): string {
  const trimmed = raw.trim().toUpperCase();
  if (/^[A-Z]{2}$/.test(trimmed)) return trimmed;
  return trimmed.slice(0, 2);
}
